<app-bread-crumbs [breadcrumbs]="breadcrumbs"></app-bread-crumbs>
<div class="home5-about-section pt-110 mb-110">
  <div class="container">
    <div class="row">
      <div
        class="col-lg-6 mt-3 wow animate fadeInLeft"
        data-wow-delay="200ms"
        data-wow-duration="1500ms"
      >
        <div class="about-content">
          <div class="section-title">
            <h2>
              <span data-translation-key="about_us_about_section_one_title">{{
                "about_us.about_section_one_title" | translate
              }}</span>
              <br />
              <span data-translation-key="buyer_footer_bidxsell">{{
                "about_us.buyer_footer_bidxsell" | translate
              }}</span>
            </h2>

            <p data-translation-key="about_us_about_section_one_content">
              {{ "about_us.about_section_one_content" | translate }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-6 mt-3">
        <div
          class="about-img wow animate fadeInRight"
          data-wow-delay="200ms"
          data-wow-duration="1500ms"
        >
          <img src="assets/images/Doug-Prather-1-1.jpg" alt="" />
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div
        class="col-lg-6 mt-3 wow animate fadeInLeft"
        data-wow-delay="200ms"
        data-wow-duration="1500ms"
      >
        <div class="about-content">
          <div class="section-title">
            <h2 data-translation-key="about_us_about_section_two_title">
              {{ "about_us.about_section_two_title" | translate }}
            </h2>

            <p data-translation-key="about_section_two_content">
              {{ "about_us.about_section_two_content" | translate }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="col-lg-6 mt-3 wow animate fadeInLeft"
        data-wow-delay="200ms"
        data-wow-duration="1500ms"
      >
        <div class="about-content">
          <div class="section-title">
            <h2 data-translation-key="about_section_three_title">
              {{ "about_us.about_section_three_title" | translate }}
            </h2>

            <p data-translation-key="about_section_three_content">
              {{ "about_us.about_section_three_content" | translate }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="col-lg-6 mt-3 wow animate fadeInLeft"
        data-wow-delay="200ms"
        data-wow-duration="1500ms"
      >
        <div class="about-content">
          <div class="section-title">
            <h2 data-translation-key="about_section_four_title">
              {{ "about_us.about_section_four_title" | translate }}
            </h2>
            <p data-translation-key="about_section_four_content">
              {{ "about_us.about_section_four_content" | translate }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="col-lg-6 mt-3 wow animate fadeInLeft"
        data-wow-delay="200ms"
        data-wow-duration="1500ms"
      >
        <div class="about-content">
          <div class="section-title">
            <h2 data-translation-key="about_section_five_title">
              {{ "about_us.about_section_five_title" | translate }}
            </h2>
            <p data-translation-key="about_section_five_content">
              {{ "about_us.about_section_five_content" | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
